module.exports = __webpack_public_path__ + "img/Secure-Auth.9f4278e.svg";